import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "layout"
};
const _hoisted_2 = {
  class: "layout_box"
};
const _hoisted_3 = {
  class: "right"
};
const _hoisted_4 = {
  class: "view"
};
import sidebar from "./components/sidebar.vue";
import navBer from "./components/Navber.vue";
const __default__ = {
  name: "Layout"
};
export default /*@__PURE__*/Object.assign(__default__, {
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(sidebar, {
        class: "sidebar-container"
      }), _createElementVNode("div", _hoisted_3, [_createVNode(navBer), _createElementVNode("div", _hoisted_4, [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_KeepAlive, null, [_createVNode(_Transition, {
          name: "component-fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))]),
          _: 2
        }, 1024)], 1024))]),
        _: 1
      })])])])]);
    };
  }
});